import PropTypes from 'prop-types';
import Constant from '@/common/constant/Constant';
import ConfirmDialog from '@/common/dialog/ConfirmDialog';
import Utils from '@/common/utils/utils';
import { openPromptTicketPanel } from '@/component/chatAI/handler/ChatAIHandler';
import { createKibanaReferencesAsAIPrompt } from '@/component/system/logKibanaHandler/LogKibanaHandler';
import { isShowKibanaAnalysisOption } from '@/component/chatAI/element/InputChatAiGroupButtons/handler/MCPServerDropdownHandler';
import { corporationAtom } from '@/state/atom/corporationAtom';
import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { userAtom } from '@/state/atom/userAtom';
import { setPanelSelector } from '@/state/selector/panelSelector';
import { isManagerByProjectInuseSelector } from '@/state/selector/projectSelector';
import {
    Button,
    Chip,
    Dialog,
    DialogContent,
    DialogTitle,
    IconButton,
    TextField,
    Typography
} from '@material-ui/core';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { useEffect, useState } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import LoadingPanel from '../../LoadingPanel';
import OverFlowTooltipWithCustomCss from '../../OverFlowTooltipWithCustomCss';
import './AIPromptModalStyle.css';
import {
    handleDeleteBasicPrompt,
    handleDisplayContentAIBody,
    handleGetAIBodyStringContent,
    handleOnBlurBasicSetting,
    initDataDefaults,
    initTicketKnowledgePrompt,
    toggleBtnSwitch
} from './HanlderAIPrompt';
import API  from '@aws-amplify/api';
import OpenAiUtil from '@/common/utils/OpenAiUtil';
import trI18n from '@/common/utils/trI18n';
import { tr } from '@/common/utils/tr';
import { useTranslationSubscription } from '@/hooks/useTranslation';

AIPromptModal.propTypes = {
    setUsingChatGptModel: PropTypes.any,
    setPromptOpen: PropTypes.any,
    isOpen: PropTypes.any,
    setIsOpen: PropTypes.any,
    projectInuseDetail: PropTypes.any,
    setTriggerReload: PropTypes.any,
    setTextInput: PropTypes.any,
    projectIdKnowledgeSelected: PropTypes.any,
    setUserSelectedPrompt: PropTypes.any,
    corporationSelected: PropTypes.any,
    promptInternalTicket: PropTypes.any,
    promptExternalTicket: PropTypes.any,
    setIsOpenModalReloadPage: PropTypes.any,
    setUsingReasoningEffort: PropTypes.func
};

export default function AIPromptModal({
    isOpen,
    setIsOpen,
    projectInuseDetail,
    setTriggerReload,
    setTextInput,
    projectIdKnowledgeSelected,
    setUserSelectedPrompt,
    corporationSelected,
    promptInternalTicket,
    promptExternalTicket,
    setIsOpenModalReloadPage,
    setPromptOpen,
    setUsingChatGptModel,
    setUsingReasoningEffort,
    setSelectedMcpServers,
    mcpServerOptions
}) {
    // Re-render when the translation dictionary loads/extends so tr()/trI18n() text updates.
    useTranslationSubscription();

    const [isLoading, setIsLoading] = useState(false);
    const [collapseInternal, setCollapseInternal] = useState(true);
    const [collapseExternal, setCollapseExternal] = useState(false);
    const [toggleUsePromptInPrj, setToggleUsePromptInPrj] = useState(false);
    const [toggleUsePromptExPrj, setToggleUsePromptExPrj] = useState(false);
    const [listExpand, setListExpand] = useState([]);
    const [listInternal, setListInternal] = useState([]);
    const [listExternal, setListExternal] = useState([]);
    const [usedProject, setUsedProject] = useState({ ...projectInuseDetail });
    const [basicSettingInPrj, setBasicSettingInPrj] = useState('');
    const [basicSettingExPrj, setBasicSettingExPrj] = useState('');
    const [errorBasicPrompt, setErrorBasicPrompt] = useState({});
    const [confirmDeleteBasicPrompt, setConfirmDeleteBasicPrompt] = useState(false);
    const [scopedDeleteBasic, setScopedDeleteBasic] = useState('');
    const [isProjectManager, setIsProjectManager] = useState(false);
    const [isMemberInProject, setIsMemberInProject] = useState(false);
    const corporationDetail = useRecoilValue(corporationAtom);
    const projectInuseDetailByAtom = useRecoilValue(projectInuseDetailAtom);
    const isPJManager = useRecoilValue(isManagerByProjectInuseSelector);
    const userDetail = useRecoilValue(userAtom);
    const [valueBasicPrompt, setValueBasicPrompt] = useState({})

    let addNewPanel = useSetRecoilState(setPanelSelector);

    useEffect(() => {
        setIsLoading(true);
        (async () => {
            try {
                let isManager = false;
                let isMember = false;
                if (projectInuseDetailByAtom.id == projectInuseDetail.id) {
                    isManager = isPJManager;
                    if (!isManager) {
                        isMember = true;
                    }
                }
                const data = await initTicketKnowledgePrompt(
                    API,
                    usedProject.affiliationOrganization,
                    projectIdKnowledgeSelected,
                    corporationDetail.id
                );

                initDataDefaults({ data, setListInternal, setListExternal, isManager, isMember });
                const projectSetting = Utils.convertJSONDataToObject(usedProject?.projectSetting);
                if (projectSetting) {
                    let switchBtnInternal = data?.infoPrompt?.promptUsage?.internalSetting;
                    let switchBtnExternal = data?.infoPrompt?.promptUsage?.externalSetting;
                    let basicSettingIn = data?.infoPrompt?.titleBasicSetting?.internalSetting;
                    let isDeletedInternalBasicPrompt = basicSettingIn === Constant.AI_PROMPT_VALID_CODE.MSG_CM_INVALID_LINK
                    let basicSettingEx = data?.infoPrompt?.titleBasicSetting?.externalSetting;
                    let isDeletedExternalBasicPrompt = basicSettingEx === Constant.AI_PROMPT_VALID_CODE.MSG_CM_INVALID_LINK

                    setValueBasicPrompt(prev => ({
                        ...prev,
                        [Constant.AI_PROMPT_SCOPED.INTERNAL_PRJ]: !isDeletedInternalBasicPrompt
                            ? projectSetting?.chatAISetting?.internalSetting?.basicPrompt || ''
                            : '',
                        [Constant.AI_PROMPT_SCOPED.EXTERNAL_PRJ]: !isDeletedExternalBasicPrompt
                            ? projectSetting?.chatAISetting?.externalSetting?.basicPrompt || ''
                            : ''
                    }));
                    if (!basicSettingIn && !isDeletedInternalBasicPrompt && projectSetting?.chatAISetting?.internalSetting?.basicPrompt) {
                        setErrorBasicPrompt(prev => ({
                            ...prev,
                            [Constant.AI_PROMPT_SCOPED.INTERNAL_PRJ]: Constant.AI_PROMPT_VALID_CODE.MSG_CM_INVALID_LINK
                        }));
                    }
                    if (!basicSettingEx && !isDeletedExternalBasicPrompt && projectSetting?.chatAISetting?.externalSetting?.basicPrompt) {
                        setErrorBasicPrompt(prev => ({
                            ...prev,
                            [Constant.AI_PROMPT_SCOPED.EXTERNAL_PRJ]: Constant.AI_PROMPT_VALID_CODE.MSG_CM_INVALID_LINK
                        }));
                    }

                    if (isDeletedInternalBasicPrompt) basicSettingIn = '';
                    if (isDeletedExternalBasicPrompt) basicSettingEx = '';

                    setToggleUsePromptInPrj(switchBtnInternal);
                    setToggleUsePromptExPrj(switchBtnExternal);

                    setIsProjectManager(isManager);
                    setIsMemberInProject(isMember);

                    if (!isManager) {
                        if (isMember) {
                            basicSettingEx = [];
                        } else {
                            basicSettingIn = [];
                            setCollapseExternal(true);
                            setCollapseInternal(false);
                        }
                    } else {
                        setCollapseExternal(false);
                        setCollapseInternal(true);
                    }

                    setBasicSettingInPrj(basicSettingIn);
                    setBasicSettingExPrj(basicSettingEx);
                }

                if (
                    projectIdKnowledgeSelected ===
                    Constant.KNOWLEDGE_VIEW_OPTION.ALL_KNOWLEDGE_IN_ORG
                ) {
                    setToggleUsePromptExPrj(true);
                    setCollapseExternal(true);
                    setIsMemberInProject(false);
                }

                setIsLoading(false);
            } catch (error) {
                console.error('error', error);
                setIsLoading(false);
            }
        })();
    }, [usedProject, projectIdKnowledgeSelected]);

    const handleToggleCollapse = collapse =>
        listExpand.includes(collapse) ? 'accordionForm--show' : '';

    const handleAddListExpand = id => {
        if (listExpand.includes(id)) {
            return setListExpand([]);
        }

        return setListExpand([id]);
    };

    const handleSaveSelectedMcpServers = (listMcpSelectedIds, extraSentinelIds = []) => {
        let listApplySelectedMcpId = [...listMcpSelectedIds];

        if (!Utils.isEmptyArray(listMcpSelectedIds)) {
            const listCanApplyMcp = !Utils.isEmptyArray(mcpServerOptions)
                ? mcpServerOptions.filter(mcp => Boolean(mcp?.isConnected))
                    .map(mcp => mcp?.id)
                    .filter(mcpId => Boolean(mcpId))
                : []

            listApplySelectedMcpId = !Utils.isEmptyArray(listCanApplyMcp)
                ? listMcpSelectedIds.filter(mcpId => listCanApplyMcp.includes(mcpId))
                : [];
        }

        // Append sentinel ids (e.g. 分析機能 KIBANA_MCP_ID) AFTER the MCP-connected filter,
        // since sentinels are frontend-only markers not present in mcpServerOptions.
        if (!Utils.isEmptyArray(extraSentinelIds)) {
            extraSentinelIds.forEach(sentinelId => {
                if (sentinelId && !listApplySelectedMcpId.includes(sentinelId)) {
                    listApplySelectedMcpId.push(sentinelId);
                }
            });
        }

        // Only update the in-memory selection (runtime state) on prompt apply — same as manual
        // MCP selection from the「+」menu (onMcpSelectionChange={setSelectedMcpServers}).
        // Do NOT persist into the tab (panelList/multiPanelAtom) here: per CR-2026-001 BR-7, the
        // selection is persisted for a tab only after the user sends at least 1 message. Persisting
        // happens in the send flow via onUpdateTabChatConfigurations (InputChatAI). Writing here
        // would make the chip survive a tab switch even without sending a message (BR-7 violation).
        setSelectedMcpServers(listApplySelectedMcpId);
    }

    const onClickUseCustomizeContent = item => {

        setUserSelectedPrompt(prev => {
            let prevClone = [...prev];
            let isExist = prevClone.some(itemCustomize => itemCustomize.id === item.id);
            if (!isExist) {
                prevClone.push({ id: item.id, title: item.title });
            }
            return prevClone;
        });
        let modelGptOfPrompt = item?.settingAI?.field_chatgpt_model_ai_auto;
        if (!Utils.isEmptyString(modelGptOfPrompt) && ![Constant.NO_PREFERENCE, Constant.NO_REFERENCE].includes(modelGptOfPrompt)) {
            const gptModel = modelGptOfPrompt.toLowerCase()
            setUsingChatGptModel(gptModel);
            if (OpenAiUtil.isSupportReasoning(gptModel)) {
                const reasoningEffort = item?.settingAI?.field_reasoning_effort_ai_auto
                setUsingReasoningEffort(reasoningEffort)
            }
        }
        let listMcpSelectedIds = !Utils.isEmptyArray(item?.listMcpSelectedIds) ? item?.listMcpSelectedIds : [];

        // 分析機能 chip: set/clear the KIBANA_MCP_ID sentinel based on the prompt's field value + preconditions.
        // Gate by PROJECT IN USE (projectInuseDetailByAtom) — NOT the prompt owner project (BR-7) —
        // to stay in sync with the submit-time gate in InputChatAI.
        const kibanaAnalysisValue = item?.settingAI?.[Constant.SYSTEM_FIELD.KIBANA_ANALYSIS];
        const isKibanaAnalysisOn =
            kibanaAnalysisValue === Constant.SYSTEM_FIELD.KIBANA_ANALYSIS_ON &&
            isShowKibanaAnalysisOption({ corporationDetail, projectInuseDetail: projectInuseDetailByAtom });

        handleSaveSelectedMcpServers(listMcpSelectedIds, isKibanaAnalysisOn ? [Constant.KIBANA_MCP_ID] : []);

        //set log kibana
        const dataLog = {
            corporationDetail: corporationDetail,
            projectDetail: projectInuseDetailByAtom,
            userDetail: userDetail,
            rootProjectDetail: projectInuseDetail,
            rootCorporationDetailId: corporationSelected,
            ticketId: item.id,
            ticketName: item.name,
            API: API
        }
        createKibanaReferencesAsAIPrompt(dataLog);
        let promptBody = handleGetAIBodyStringContent(item.settingAI.AIPromptBody);
        // Decode escaped angle brackets globally: prompt body is stored HTML-escaped (richtext),
        // so halfwidth <> markers (e.g. <sdauto>, <shareLinkUrl>) must be restored for the plain textarea.
        let promptBodyText = promptBody
            .replace(/<br\s*\/?>/gi, '\n')
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>');
        setTextInput(prev => prev + promptBodyText);
        return setIsOpen(!isOpen);
    };

    const renderBasicSetting = (basicSetting, inputSetting, promptTicket) => {
        const valueBasicSetting =
            inputSetting === Constant.AI_PROMPT_SCOPED.INTERNAL_PRJ
                ? valueBasicPrompt[Constant.AI_PROMPT_SCOPED.INTERNAL_PRJ]
                : valueBasicPrompt[Constant.AI_PROMPT_SCOPED.EXTERNAL_PRJ];

        return (
            <div className="prompt-basic-chip">
                <span>{trI18n('CM-LABEL-BASIC')}</span>
                {!basicSetting ? (
                    <TextField
                        className="form-control-input form-control-wrapInput form-control-hg32 setting-inputs input-basic-chip"
                        variant="outlined"
                        spellCheck={false}
                        autoComplete="seriously-please-don't-autocomplete"
                        type="text"
                        defaultValue={valueBasicSetting}
                        onBlur={async e =>
                            await handleOnBlurBasicSetting(
                                e,
                                API,
                                projectInuseDetail.id,
                                inputSetting,
                                Constant.SETTING_AI_PROMPT_ACTION.SETTING_BASIC_PROMPT,
                                setIsLoading,
                                setUsedProject,
                                setErrorBasicPrompt,
                                setTriggerReload,
                                setValueBasicPrompt
                            )
                        }
                        helperText={trI18n(errorBasicPrompt[inputSetting])}
                        error={!Utils.isEmptyString(errorBasicPrompt[inputSetting])}
                    />
                ) : (
                    <Chip
                        label={<OverFlowTooltipWithCustomCss value={basicSetting} />}
                        onClick={()=> {
                            if (Utils.isEmptyObject(promptTicket)) return;
                            setPromptOpen(false);
                            openPromptTicketPanel(
                                setIsLoading,
                                userDetail,
                                promptTicket.id,
                                projectInuseDetail,
                                setIsOpenModalReloadPage,
                                addNewPanel
                            );
                        }}
                        onDelete={() => {
                            setConfirmDeleteBasicPrompt(!confirmDeleteBasicPrompt);
                            setScopedDeleteBasic(inputSetting);
                        }}
                        deleteIcon={<img className='basic-chip-delete-icon' src="/assets/image/delete-icon-rounded.svg" alt="delete"/>}
                        className="basic-chip setting-inputs"
                    />
                )}
            </div>
        );
    };

    const renderHeader = (kind, promptTicket) => {
        let prototype = {
            title: trI18n('LABEL-PRJ-IN-USE'),
            btnSwitchTitle: trI18n('LABEL-USE-PROMPT'),
            toggleBtn: toggleUsePromptInPrj,
            setToggle: setToggleUsePromptInPrj,
            kindCollapse: collapseInternal,
            setKindCollapse: setCollapseInternal,
            basicSetting: basicSettingInPrj
        };

        if (kind === 'outPrj') {
            prototype = {
                ...prototype,
                title: trI18n('LABEL-PROMPT-USE-FOR-OUTSIDE-PRJ'),
                toggleBtn: toggleUsePromptExPrj,
                setToggle: setToggleUsePromptExPrj,
                kindCollapse: collapseExternal,
                setKindCollapse: setCollapseExternal,
                basicSetting: basicSettingExPrj
            };
        }

        if (!isProjectManager) {
            return null;
        }

        return (
            <div className="prompt-content-header">
                <div className='prompt-content-head'>
                    <div className="prompt-use-title">
                        {prototype.title}{' '}
                        <img
                            src="/assets/image/icon-listEmpty.svg"
                            alt="icon-warning"
                            // style={{ opacity: 0.7 }}
                        />
                    </div>
                    <div className="prompt-toggle-status">
                        <label htmlFor="prj-toggle">{prototype.btnSwitchTitle}</label>
                        <div className="switch-check">
                            <input
                                type="checkbox"
                                checked={prototype.toggleBtn}
                                id={`prj-toggle-${kind}`}
                                value="1"
                                onChange={async () =>
                                    await toggleBtnSwitch(
                                        API,
                                        projectInuseDetail.id,
                                        kind,
                                        Constant.SETTING_AI_PROMPT_ACTION.UPDATED_USAGE_PROMPT,
                                        !prototype.toggleBtn,
                                        prototype.setToggle,
                                        setIsLoading,
                                        setUsedProject
                                    )
                                }
                            />
                            <label htmlFor={`prj-toggle-${kind}`}></label>
                        </div>
                    </div>
                </div>
                <div className='prompt-content-head'>
                    {renderBasicSetting(prototype.basicSetting, kind, promptTicket)}
                    <IconButton
                        className={`prompt-collapse`}
                        onClick={e => prototype.setKindCollapse(!prototype.kindCollapse)}
                    >
                        {prototype.kindCollapse ? (
                            <ExpandMoreIcon/>
                            ) : (
                            <ExpandLessIcon/>
                        )}
                    </IconButton>
                </div>
            </div>
        );
    };

    const renderContentPrompt = (listItem, toggleUseBtn, scoped) => {
        const noDataFound = <div className="prj-body accordionForm data-not-found">{trI18n('MSG-CM-NO-DATA-FOUND')}</div>;
        if (Utils.isEmptyArray(listItem)) {
            return noDataFound;
        }

        if (!isProjectManager) {
            switch (scoped) {
                case Constant.AI_PROMPT_SCOPED.INTERNAL_PRJ:
                    if (!toggleUsePromptInPrj) {
                        if(isMemberInProject) {
                            return noDataFound;
                        }
                        return null;
                    }
                    break;
                case Constant.AI_PROMPT_SCOPED.EXTERNAL_PRJ:
                    if (!toggleUsePromptExPrj && !isMemberInProject) {
                        if(!isMemberInProject) {
                            return noDataFound;
                        }
                        return null;
                    }
                    break;
                default:
                    break;
            }
        }

        const displayClass = () => {
            if (scoped == Constant.AI_PROMPT_SCOPED.INTERNAL_PRJ) {
                return toggleUsePromptInPrj ? 'prompt-content-question-with-use-prompt' : 'prompt-content-question-full-width';
            }

            return toggleUsePromptExPrj ? 'prompt-content-question-with-use-prompt' : 'prompt-content-question-full-width';
        }

        return listItem.map((item, index) => (
            <div
                className={`prj-body accordionForm ${handleToggleCollapse(`${item.id}-${scoped}`)}`}
                id={`${item.id}-${scoped}`}
                key={index}
            >
                <div className="accordionHead-promptAI" onClick={e => handleAddListExpand(`${item.id}-${scoped}`)}>
                    {/* <span className="accordionHead-item">
                        <img src="/assets/image/icon-pin.svg" alt="" />
                    </span> */}
                    <OverFlowTooltipWithCustomCss
                        className="accordionHead-text"
                        value={tr(item.title)}
                        style={{"padding-right": "15px"}}
                    />
                </div>
                <div className="accordionContent ticket-content">
                    <div className={`prompt-content-question ${displayClass()}`}>
                        <Typography
                            component="div"
                            variant="body2"
                            paragraph={false}
                            className="content-show"
                            dangerouslySetInnerHTML={{
                                __html: item.settingAI.AIPromptBody
                                    ? handleDisplayContentAIBody(item.settingAI.AIPromptBody, true)
                                    : ''
                            }}
                        ></Typography>
                    </div>
                    {toggleUseBtn && (
                        <div className="prompt-btn-use">
                            <Button
                                color="primary"
                                className="btn-send btn-hg32 btn-outline-primary"
                                variant="outlined"
                                onClick={() => onClickUseCustomizeContent(item)}
                            >
                                {tr('適用')}
                            </Button>
                        </div>
                    )}
                </div>
            </div>
        ));
    };

    const handleClose = (event, reason) => {
        if (reason && reason == 'backdropClick') {
            return setIsOpen(!isOpen);
        }

        return;
    };

    return (
        <Dialog
            open={isOpen}
            onClose={(event, reason) => handleClose(event, reason)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            className="wrapDialog"
        >
            <LoadingPanel isLoading={isLoading} />
            <DialogTitle id="ai-prompt-title" disableTypography={true}>
                <span className="prompt-title-content">
                    {trI18n('CM-LABEL-TITLE-PROMPT-LIST')}
                </span>
            </DialogTitle>
            <DialogContent id="ai-prompt-content">
                {/* internal project */}
                <div className="prompt-content">
                    {renderHeader(Constant.AI_PROMPT_SCOPED.INTERNAL_PRJ, promptInternalTicket)}
                    {collapseInternal && renderContentPrompt(listInternal, toggleUsePromptInPrj, Constant.AI_PROMPT_SCOPED.INTERNAL_PRJ)}
                </div>
                {/* external project */}
                <div className="prompt-content border-top-solid">
                    {renderHeader(Constant.AI_PROMPT_SCOPED.EXTERNAL_PRJ, promptExternalTicket)}
                    {collapseExternal && renderContentPrompt(listExternal, toggleUsePromptExPrj, Constant.AI_PROMPT_SCOPED.EXTERNAL_PRJ)}
                </div>
                {confirmDeleteBasicPrompt && <ConfirmDialog
                    isOpen={confirmDeleteBasicPrompt}
                    msgConfirm={trI18n('MSG-AI-CONFIRM-DELETE-BASIC-PROMPT')}
                    closeCallBack={() => setConfirmDeleteBasicPrompt(false)}
                    okCallBack={async () => {
                        await handleDeleteBasicPrompt(
                            API,
                            projectInuseDetail.id,
                            scopedDeleteBasic,
                            Constant.SETTING_AI_PROMPT_ACTION.DELETED_BASIC_PROMPT,
                            setIsLoading,
                            setConfirmDeleteBasicPrompt,
                            setUsedProject,
                            
                        );
                        setTriggerReload(Date.now().toString());
                        setScopedDeleteBasic('');
                    }}
                    textSubmit={trI18n('COMBTN002')}
                    textClose={trI18n('COMBTN007')}
                    className={'confirm-delete-basic'}
                />}
            </DialogContent>
        </Dialog>
    );
}
